import { createFileRoute } from '@tanstack/react-router';
import { ClientCardPage } from '../features/records/ClientCardPage';
import { validateCardSearch } from '../lib/cardSearch';

export const Route = createFileRoute('/clients/$id')({
  validateSearch: validateCardSearch,
  component: function CardRoute() {
    const { id } = Route.useParams();
    return <ClientCardPage id={id} />;
  },
});
